import { Column, Entity, Index, PrimaryGeneratedColumn } from "typeorm";

@Index("estatus", ["estatus"], {})
@Entity("subject")
export class Subject {
  @PrimaryGeneratedColumn({ type: "int", name: "id" })
  id: number;

  @Column("int", { name: "class" })
  class: number;

  @Column("varchar", { name: "subject", length: 100, default: () => "''" })
  subject: string;

  @Column("varchar", { name: "subject_code", length: 20, nullable: true })
  subjectCode: string;

  @Column("int", { name: "language" })
  language: number;

  @Column("varchar", { name: "estatus", length: 2, default: () => "'1'" })
  estatus: string;

  @Column("varchar", { name: "timestamp", length: 20, default: () => "''" })
  timestamp: string;

  @Column("int", { name: "qpcode" })
  qpcode: number;

  @Column("bigint", { name: "subject_parent_id" })
  subjectParentId: number;
}
